import React from 'react'
import { Grid } from './Grid'
import { GridCell } from './GridCell'
import styles from './LineBreaker.less'

export function LineBreaker (props) {
  const { text = '' } = props
  return <Grid paddingX marginX>
    <GridCell medium={12} >
      <div className= {styles.BreakerControl}>
        <p>{text}</p>
      </div>
    </GridCell>
  </Grid>
}
